import { Component } from '@angular/core';
import { cv_MaterialOrigin, cv_MaterialType, cv_OrderStatus, WorkgroupUser } from '@common/types';
import { OrderDetailService } from '../../services/order-detail.service';
import { ORDER_DETAIL_FIELD } from '../../order-setting-fields';

@Component({
    selector: 'order-detail-summary',
    templateUrl: './order-detail-summary.component.html',
})
export class OrderDetailSummaryComponent {
    summaryField = ORDER_DETAIL_FIELD.summary

    constructor(
        public orderDetailService: OrderDetailService,
    ) { }

    materialTypeKeyFormatter = (value: cv_MaterialType): number => {
        return value.C_MaterialType_key;
    }
    materialTypeFormatter = (value: cv_MaterialType): string => {
        return value.MaterialType;
    }

    orderStatusKeyFormatter = (value: cv_OrderStatus): number => {
        return value.C_OrderStatus_key;
    }
    orderStatusFormatter = (value: cv_OrderStatus): string => {
        return value.OrderStatus;
    }

    materialOriginKeyFormatter = (value: cv_MaterialOrigin): number => {
        return value.C_MaterialOrigin_key;
    }
    materialOriginFormatter = (value: cv_MaterialOrigin): string => {
        return value.MaterialOrigin;
    }
}
